import React from 'react';
import styled, { css } from 'styled-components';
import Button from '~/components/atom/Button';
import TEST_ID from './index.testid';
import TextButton from '~/components/atom/TextButton';
import JustificationContainer from '~/components/atom/JustificationContainer';

const text = {
  goBack: 'Ga Terug',
  cancel: 'Annuleer',
};
type Props = {
  onGoBack?: () => void;
  nextStepButton?: string;
  onContinue?: () => void;
  onCancel?: () => void;
  loading?: boolean;
  disabled?: boolean;
  submitButton?: boolean;
  accentButton?: boolean;
};
const BottomSectionContainer: React.FCC<Props> = ({
  onGoBack,
  nextStepButton,
  onContinue,
  children,
  onCancel,
  loading,
  disabled,
  submitButton,
  accentButton,
}) => (
  <Container align="center" wrap="wrap" justification="space-between">
    {onGoBack && (
      <TextButton
        size="medium"
        label={text.goBack}
        onClick={onGoBack}
        dataTestId={TEST_ID.GO_BACK_BUTTON}
        padding={[null]}
      />
    )}
    <ButtonContainer>
      {onCancel && (
        <Button size="medium" ghost onClick={onCancel} label={text.cancel} />
      )}
      {nextStepButton && (
        <Button
          size="medium"
          appearance={accentButton ? 'accent' : 'secondary'}
          onClick={onContinue}
          loading={loading}
          dataTestId={TEST_ID.NEXT_STEP_BUTTON}
          disabled={disabled}
          type={submitButton ? 'submit' : 'button'}
          label={nextStepButton}
        />
      )}
    </ButtonContainer>
    {children}
  </Container>
);

const Container = styled(JustificationContainer)<{}>`
  align-self: flex-end;
  width: 100%;

  ${({ theme }) => css`
    padding: ${theme.space('l')} ${theme.space('xxxxl')};
    background-color: ${theme.color('tertiary', 'translucent')};
  `};
`;

const ButtonContainer = styled.div<{}>`
  align-self: center;

  ${({ theme }) => css`
    button {
      margin-left: ${theme.space('m')};
    }
  `};
`;

export default BottomSectionContainer;
